import { TOC_HOST } from '../../../../config';
import { MessageIframe } from '../../../message-type/message-iframe';
import { IQQIframeData } from './qq-login-message.interface';
// qq登录调起不用进行私有化cac配置整改
var DOCS_ORIGIN = TOC_HOST;
var QQLoginMessage = /** @class */ (function () {
    function QQLoginMessage() {
        this.getQQLoginMessage = new MessageIframe(this.getQQLoginMessageCheckFn);
    }
    QQLoginMessage.prototype.connect = function () {
        this.getQQLoginMessage.connect();
    };
    QQLoginMessage.prototype.dispose = function () {
        this.getQQLoginMessage.dispose();
        this.qqIframeMountListener = undefined;
    };
    QQLoginMessage.prototype.getQQLoginSuccessMessage = function (listener) {
        this.getQQLoginMessage.receive(listener);
    };
    QQLoginMessage.prototype.getQQIframeMessage = function (listener) {
        this.qqIframeMountListener = listener;
    };
    QQLoginMessage.prototype.createQQLoginIframe = function (dom, src) {
        var _this = this;
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.frameBorder = '0';
        iframe.scrolling = 'auto';
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.id = 'login_frame';
        iframe.name = 'login_frame';
        iframe.onload = function () {
            var _a;
            (_a = _this.qqIframeMountListener) === null || _a === void 0 ? void 0 : _a.call(_this, new MessageEvent(IQQIframeData.QQ_IFRAME_MOUNT));
        };
        dom.appendChild(iframe);
        return iframe;
    };
    QQLoginMessage.prototype.getQQLoginMessageCheckFn = function (message) {
        var data = message.data, origin = message.origin;
        if (origin.indexOf(DOCS_ORIGIN)
            && (data === IQQIframeData.QQ_LOGIN_SUCCESS
                || (typeof data === 'string' && data.startsWith(IQQIframeData.QQ_OAUTH_LOGIN_SUCCESS)))) {
            return true;
        }
        return false;
    };
    return QQLoginMessage;
}());
export { QQLoginMessage };
